module.exports = __webpack_public_path__ + "static/media/step4.b709d4b1.png";